export default {
  videoModeChanged: 'VIDEO_MODE_CHANGED',
};



// WEBPACK FOOTER //
// ./constants/videoActionTypes.js